import {
  LegalFooter,
  legalPaths,
} from "@/lib/components/ui/legal-footer/legal-footer";
import ThemeProvider from "@/lib/theme/theme-provider";
import { documentStyle } from "@/lib/theme/document-style";
import { streamdownShikiTheme } from "@/lib/theme/streamdown-shiki-theme";
import { Streamdown } from "streamdown";
import { Outlet, type RouteObject } from "react-router";

// markdown bundled at build time; edit the .md files in ./content to change the text
const documents = import.meta.glob("./content/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

function documentText(name: string) {
  return documents[`./content/${name}.md`] ?? "";
}

// public layout for the legal pages, no auth so it works straight from the login box
function LegalLayout() {
  return (
    <ThemeProvider>
      <div className="bg-background flex min-h-svh flex-col">
        <main className="mx-auto w-full max-w-3xl grow px-6 py-12">
          <Outlet />
        </main>
        <LegalFooter className="p-6" showLogin />
      </div>
    </ThemeProvider>
  );
}

function LegalPage({ name }: { name: string }) {
  return (
    <Streamdown
      className={documentStyle}
      mode="static"
      parseIncompleteMarkdown={false}
      shikiTheme={streamdownShikiTheme}
    >
      {documentText(name)}
    </Streamdown>
  );
}

const legalRoutes: RouteObject[] = [
  {
    element: <LegalLayout />,
    children: [
      {
        path: legalPaths.impressum,
        element: <LegalPage name="impressum" />,
      },
      {
        path: legalPaths.privacy,
        element: <LegalPage name="datenschutz" />,
      },
      {
        path: legalPaths.terms,
        element: <LegalPage name="nutzungsbedingungen" />,
      },
      {
        path: legalPaths.anonymization,
        element: <LegalPage name="anonymization" />,
      },
    ],
  },
];

export default legalRoutes;
